import Vue from 'vue'

const mask = {
  cnpj: '##.###.###/####-##',
  cep: '##.###-###',
  cpf: '###.###.###-##',
  date: '##/##/####',
  phone: '(##) #####-####'
}

Vue.prototype.mask = mask
